import React, { useEffect } from "react";
import './contentPc.scss'

function ContentPc(props) {
    useEffect(() => {

    }, [])
    return (
        <>
            <div className="content_pc">
                <img src="assets/dr.gif" alt="" className="img"></img>
            </div>
        </>
    )
}
export default ContentPc